/**
 * @generated SignedSource<<05f748b5a6c8adbf92302798905bd021>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum PublicLinkPageStatus {
  BLOCKED_BY_ORG = "BLOCKED_BY_ORG",
  BLOCKED_BY_PRODUCT = "BLOCKED_BY_PRODUCT",
  BLOCKED_BY_SPACE = "BLOCKED_BY_SPACE",
  BLOCKED_BY_CONTAINER_POLICY = "BLOCKED_BY_CONTAINER_POLICY",
  BLOCKED_BY_CLASSIFICATION_LEVEL = "BLOCKED_BY_CLASSIFICATION_LEVEL",
  OFF = "OFF",
  ON = "ON",
  SITE_BLOCKED = "SITE_BLOCKED",
  SITE_DISABLED = "SITE_DISABLED",
  SPACE_BLOCKED = "SPACE_BLOCKED",
  SPACE_DISABLED = "SPACE_DISABLED",
}
export type usePublicLinkPageDataProviderPublicLinkPageQuery_publicLinkPage_PublicLinkPage =
  {
    __typename?: "PublicLinkPage";
    pageId: string;
    pageStatus: PublicLinkPageStatus;
    publicLinkUrlPath: string | null;
  };
export type usePublicLinkPageDataProviderPublicLinkPageQuery_Query = {
  __typename?: "Query";
  publicLinkPage: usePublicLinkPageDataProviderPublicLinkPageQuery_publicLinkPage_PublicLinkPage | null;
};
export type usePublicLinkPageDataProviderPublicLinkPageQueryVariables = Exact<{
  pageId: Scalars["ID"]["input"];
}>;
export type usePublicLinkPageDataProviderPublicLinkPageQuery =
  usePublicLinkPageDataProviderPublicLinkPageQuery_Query;
